import { useClaims, useHasPermission } from "../../auth/useClaims";

// Technical Site Survey permissions (Batch216). These only decide what to SHOW;
// the per-record buttons (edit / complete / cancel / convert) are driven by the
// detail's own canEdit/canComplete/canCancel/canConvert flags, which the server
// computes from status + creator + these same codes.
//
// Technical.CreateSurvey - technician: create, edit/complete/cancel own DRAFTs, sees own only.
// Technical.ViewSurveys  - sees every survey in their branches (read-only).
// Quotation.Create       - quotation people: see all, edit/cancel COMPLETED, convert.
export const SURVEY_PERMISSIONS = ["Technical.ViewSurveys", "Technical.CreateSurvey", "Quotation.Create"];

export const useCanCreateSurvey = () => useHasPermission("Technical.CreateSurvey");
export const useCanViewAllSurveys = () => {
  const { permissions } = useClaims();
  return permissions.includes("Technical.ViewSurveys") || permissions.includes("Quotation.Create");
};
export const useCanQuoteSurveys = () => useHasPermission("Quotation.Create");
